// extracted by mini-css-extract-plugin
export default {"mainContainer":"HomePageSearch_mainContainer__6f34+"};